import React from "react";
import { Award } from "lucide-react";
import { TransformedProfileData } from "@/types/publicProfile";
import { Section } from "./Section";

interface AwardsSectionProps {
  awards: TransformedProfileData["sections"]["awards"]["items"];
}

export const AwardsSection: React.FC<AwardsSectionProps> = ({ awards }) => {
  return (
    <Section
      id="awards"
      title="Awards & Recognition"
      icon={<Award className="h-5 w-5" />}
    >
      <div className="grid gap-4 md:grid-cols-2">
        {awards
          .filter((award) => award.privacy.isVisible)
          .map((award) => (
            <article key={award.id} className="card-apple p-5">
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <h3 className="text-base font-semibold">{award.title}</h3>
                  <div className="mt-1 text-sm text-secondary">
                    {award.issuer}
                  </div>
                  <div className="mt-2 text-xs text-tertiary">
                    {new Date(award.date).toLocaleDateString()}
                  </div>
                  {award.description && (
                    <p className="mt-2 text-sm text-secondary">
                      {award.description}
                    </p>
                  )}
                </div>
                {award.logo && (
                  <img
                    src={award.logo}
                    alt={award.issuer}
                    className="h-8 w-8 rounded object-contain"
                  />
                )}
              </div>
              {award.link && (
                <a
                  href={award.link}
                  target="_blank"
                  rel="noreferrer"
                  className="mt-2 inline-flex items-center gap-1 text-xs text-primary hover:underline"
                >
                  View Award
                </a>
              )}
            </article>
          ))}
      </div>
    </Section>
  );
};
